import { observer } from 'mobx-react-lite'
import { StyleSheet, View } from 'react-native'
import { ActivityIndicator } from 'react-native-paper'

import { useStore } from '../../../models'
import { color, fontFamily } from '../../../theme'
import { Button, ButtonProps } from '../Button'

interface BottomModalButtonProps extends ButtonProps {
  alternateFont?: boolean
  alternateColor?: boolean
}
//TODO: We will deprecate this component
export const BottomModalButton = observer(
  ({ text, onPress, size, icon, alternateFont, alternateColor, textStyle }: BottomModalButtonProps) => {
    const containerStyle = [alternateColor ? styles.alternateContainer : {}]
    const customTextStyle = [alternateColor ? styles.alternateText : {}, alternateFont ? styles.alternateFont : {}]
    const {
      game: { showConfirmLoader, showCancelLoader }
    } = useStore()

    const showIndicator = (!alternateColor && showConfirmLoader) || (alternateColor && showCancelLoader)

    return (
      <View>
        {showIndicator ? (
          <View style={[styles.indicator, containerStyle]}>
            <ActivityIndicator
              size={'small'}
              color={alternateColor ? color.palette.maroon : color.palette.white}
              style={{ marginLeft: 8 }}
            />
          </View>
        ) : (
          <Button
            icon={icon}
            text={text}
            onPress={onPress}
            size={size}
            containerStyle={containerStyle}
            textStyle={[customTextStyle, textStyle]}
          />
        )}
      </View>
    )
  }
)

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 20,
    width: '70%'
  },
  title: {
    fontSize: 24,
    textAlign: 'center'
  },
  // container: {

  // },
  alternateContainer: {
    backgroundColor: 'unset',
    borderColor: 'lightgray',
    borderWidth: 1
  },
  alternateFont: {
    fontFamily: fontFamily.FeatureDeckRegular
  },
  alternateText: {
    color: 'black'
  },
  indicator: {
    paddingVertical: 13,
    paddingHorizontal: 6,
    width: '100%',
    backgroundColor: color.palette.black,
    borderRadius: 50
  }
})
